/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var skipTags = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1 };

  function stripTextNode(node) {
    if (!node || node.nodeType !== 3) return;
    var parent = node.parentNode;
    if (!parent || skipTags[parent.nodeName]) return;

    var value = node.nodeValue;
    if (!value || (value.indexOf('.00') === -1 && value.indexOf('PKR') === -1)) return;

    var next = value
      .replace(/(\d)\.00(?!\d)/g, '$1')
      .replace(/(\d)\s*PKR\b/g, '$1')
      .replace(/\bPKR\s*(?=\d)/g, '');
    if (next !== value) node.nodeValue = next;
  }

  function stripTree(root) {
    if (!root) return;
    if (root.nodeType === 3) {
      stripTextNode(root);
      return;
    }
    if (root.nodeType !== 1 || skipTags[root.nodeName]) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var batch = [];
    var node;
    while ((node = walker.nextNode())) batch.push(node);
    for (var i = 0; i < batch.length; i++) stripTextNode(batch[i]);
  }

  function start() {
    if (!document.body || document.body.getAttribute('data-strip-price-zeros') === 'true') return;
    document.body.setAttribute('data-strip-price-zeros', 'true');

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === 'characterData') {
          stripTextNode(mutation.target);
        } else {
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            stripTree(mutation.addedNodes[j]);
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    stripTree(document.body);
    window.addEventListener('load', function () {
      stripTree(document.body);
    });
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();